import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { request } from "utils/request";
import { selectPagination } from "app/components/TimezoneSelection/redux/selector";
import { actions } from "app/components/TimezoneSelection/redux/slice";
import { IPagination } from "app/types";
import { handleApiError } from "utils/errorHandler";

export function* doFetchListRequest() {
  try {
    // Only add delay for first page to improve UX for infinite scroll
    const pagination: IPagination = yield select(selectPagination);
    if (pagination.page === 1) {
      yield delay(500);
    }

    yield put(actions.setLoading(true));
    const queryParams = `page=${pagination.page}&perPage=${pagination.perPage}${
      pagination?.search && pagination.search.length > 0 ? "&search=" + pagination.search : ""
    }`;
    const requestURL = `${API_URL}auth/timezone/list?${queryParams}`;
    const options = {
      method: "GET",
    };

    const { data, err } = yield call(request, requestURL, options);
    yield put(actions.setLoading(false));

    if (err || !data) {
      handleApiError(err);
      return;
    }

    const results = data.data;
    const meta = data._metadata.pagination;

    yield put(actions.setList(results));
    yield put(actions.setPagination(meta));
  } catch (err: any) {
    yield put(actions.setLoading(false));
    handleApiError(err);
  }
}

export default function* TimeZoneSaga() {
  yield takeLatest(actions.doFetchList, doFetchListRequest);
}
